import styled from 'styled-components';

import { breakpoints, css } from '@notino/react-styleguide';

const TabWrapper = styled.div<{ newPdDesignEnabled: boolean }>`
  ${({ newPdDesignEnabled }) =>
    !newPdDesignEnabled &&
    css`
      margin: 0 -0.9375rem;
    `}

  @media (min-width: ${breakpoints.md}) {
    margin: 0;
  }
`;

export default TabWrapper;
